import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { DocumentsCatalogKey } from './documents.i18n.js';
import { DOCUMENTS_CATALOG } from './documents.i18n.js';

export type DocumentsMessageId = `documents:${DocumentsCatalogKey}`;

const PREFIX_LENGTH = 'documents:'.length;

/** `t()` for the stop-gap `documents:` scope (see `documents.i18n.ts`). */
export function useDocumentsT(): { t: (id: DocumentsMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: DocumentsMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as DocumentsCatalogKey;
      const raw = DOCUMENTS_CATALOG[locale][key] ?? DOCUMENTS_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
